import { useContext, useEffect, useMemo, useRef, useState } from "react";

import Input from "shared/Input/Input";

import { ArrowRightIcon, ArrowSmallLeftIcon, ChatBubbleLeftRightIcon, Squares2X2Icon } from "@heroicons/react/24/outline";
import ButtonCircle from "shared/Button/ButtonCircle";
import { requestAPI } from "utils/api";
import { UIContext } from "contexts/UIContext";
import { GlobalDataContext } from "contexts/GlobalData";

import CommentListing from "./CommentListing";
import SigninForm from "components_custom/SigninForm/SigninForm";
import GuestAvatar from "assets/images/guest.png";

const fieldEmptyCheck = (text : string) => {
	//공백이 있으면 true
	
	const regex = /^\s*$/;

	// console.log(text === '');
	// console.log(text === null);
	// console.log(text === undefined);
	// console.log();

	if (text === '' || text === null || text === undefined || regex.test(text)) {
	  return "HasEmpty";     
	}
	
	return 'NoEmpty';
}

const ChatList = ({
	isReserve,
	no
}: any) => {

	const {
		toast,
		modal,
	} = useContext(UIContext);  

	const { 
		initData
	} = useContext (GlobalDataContext);

	const [chatList, setChatList] = useState <[]> ([]);
	const [chatContents, setChatContents] = useState("");

	const chatbox = useRef <any> (null);

	useMemo (async () => {
		
			const res: any = await requestAPI('GET', `v1/chat/product/${no}`, null);
			console.log(res);
			setChatList(res.data.list);
	}, []);

	useEffect(()=>{
		if(chatbox.current !== null) {
			chatbox.current.scrollTop = chatbox.current.scrollHeight;
		}
	}, [chatList]);

	const formatKoreanDate = (dateString: string) => {
		const date = new Date(dateString);
		
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2);
		const day = ('0' + date.getDate()).slice(-2);
		
		let hours = date.getHours();
		const minutes = ('0' + date.getMinutes()).slice(-2);
		const seconds = ('0' + date.getSeconds()).slice(-2);
		
		const formattedTime2 = `${(hours < 10?"0":"")}${hours}:${minutes}`;

		const period = hours >= 12 ? '오후' : '오전';
		hours = hours % 12 || 12; // 0 => 12
	
		const formattedDate = `${year}.${month}.${day}`;
		
		const formattedTime = `${period} ${hours}:${minutes}:${seconds}`;
	
		return {
			date: formattedDate,
			time: formattedTime,
			time2: formattedTime2,
			year: year,
			month: month,
			day: day,
		};
	};


	const MessageMe = ({item}: any) => {
		const date = formatKoreanDate(item.createdAt);
		console.log("url", item.user_profileUrl);
		const url = (item.user_profileUrl===null)
		? `${process.env.REACT_APP_SERVER_FILE}/static/avatar/guest.png` 
	  	: `${process.env.REACT_APP_SERVER_FILE}/avatar/${item.user_profileUrl}`;

		return (
			<div className="flex gap-2.5 justify-end">
				
				<div className="flex items-start">	
					<div className="grid mb-2">
						<h5 className="text-right text-gray-900 text-sm font-semibold leading-snug pb-1">{item.user_displayName}</h5>
						<div className="px-3 py-2 bg-indigo-600 rounded">
							<h2 className="text-white text-sm font-normal leading-snug">{item.comment}</h2>
						</div>
						<div className="justify-start items-center inline-flex">
							<h3 className="text-gray-500 text-xs font-normal leading-4 py-1">{`${date.date} ${date.time2}`}</h3>
						</div>
					</div>

					<div className="ml-2.5">
						<img src={`${url}`} alt="Hailey image" className="w-10 h-11" />
					</div>
				</div>
			</div>
		);
	};

	const MessageOther = ({item}: any) => {
		const date = formatKoreanDate(item.createdAt);
		console.log("url", item.user_profileUrl);
		const url = (item.user_profileUrl===null)
		? `${process.env.REACT_APP_SERVER_FILE}/static/avatar/guest.png` 
	  	: `${process.env.REACT_APP_SERVER_FILE}/avatar/${item.user_profileUrl}`;

		return (
			<div className="grid pb-2">
				<div className="flex gap-2.5">
					<img src={`${url}`} alt="Hailey image" className="w-10 h-11" />
					<div className="grid">
						<h5 className="text-gray-900 text-sm font-semibold leading-snug pb-1">{item.user_displayName}</h5>
						<div className="grid">
							<div className="px-3.5 py-2 bg-gray-100 rounded justify-start  items-center gap-3 inline-flex">
								<h5 className="text-gray-900 text-sm font-normal leading-snug">{item.comment}</h5>
							</div>
							<div className="justify-end items-center inline-flex mb-2.5">
								<h6 className="text-gray-500 text-xs font-normal leading-4 py-1">{`${date.date} ${date.time2}`}</h6>
							</div>
						</div>
					</div>
				</div>
			</div>
		);	
	}

	const handleChatSaveRequest = async () => {

		if (initData.token_info.permission_group === "guest") {
			
			modal({
				title: "로그인", 
				contents: <SigninForm modalSw={true} />,
				buttons: []
			});	

			return toast ({
				type: 'warning', 
				contents: '로그인이 필요해요'
			});
		}

		console.log("123>>", isReserve);

		if (isReserve === null) {
			return toast ({
				type: 'warning', 
				contents: '예약 확정자만 참여할 수 있어요.'
			});
		} else if ( isReserve.status === "READY") {
			return toast ({
				type: 'warning', 
				contents: '현재 예약 대기중 이며 입금이 완료된 이후 예약 확정자만 채팅에 참여할 수 있어요.'
			});
		} else if ( isReserve.status === "DEPOSITED") {
			return toast ({
				type: 'warning', 
				contents: '현재 입금이 완료된 상태이며 예약 확정자만 채팅에 참여할 수 있어요.'
			});
		}

		let isEmpty = fieldEmptyCheck(chatContents);
		
		if (isEmpty === "HasEmpty") {
			return toast ({
				type: 'warning', 
				contents: '내용을 입력해 주세요.'
			});
		}

		const res_info: any = await requestAPI ('POST', `v1/chat/product/${no}`, {
			comment: chatContents,
		});

		setChatList(res_info.data.chatList);

		if(chatbox.current !== null) {
			chatbox.current.scrollTop = chatbox.current.scrollHeight;
		}
	};

	return (
		
			
		<div  id="chatting" className="listingSection__wrap space-y-0 p-0">
			
			<div className="pl-5 pt-5">
				<h2 className="text-lg sm:text-2xl font-semibold">투어 참가자 채팅</h2>
				<div className="pt-3 w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
			</div>
			<div className="pt-5" />
			{/* <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div> */}
			
			<div className="rounded-2xl w-full h-[460px] relative bg-white">
				<div className="pl-5 pr-5 pt-5 h-[380px] overflow-y-scroll" ref={chatbox}>
					{chatList.map ((item: any, idx: number) => {
			
						if (item.user_id === initData.userInfo._id) {
							return (
								<MessageMe
									key={`chatlist_${idx}`}
									item={item}
								/>
							);
						} else {
							return (
								<MessageOther
									key={`chatlist_${idx}`}
									item={item}
								/>
							);
						}
					})}
					
				</div>
				
				<div id="chat" className="w-full items-center inline-flex justify-between sticky bottom-0 pb-3 pl-3 pr-3 rounded-2xl">
					
					<div className="relative w-full">
						<Input
							value={chatContents}
							onChange={e => setChatContents(e.target.value)}
							fontClass=""
							sizeClass="h-16 px-4 py-3"
							rounded="rounded-3xl"
							placeholder="질문 또는 후기를 남겨주세요..."
						/>
						<ButtonCircle
							onClick={() => handleChatSaveRequest()}
							className="absolute right-2 top-1/2 transform -translate-y-1/2"
							size=" w-12 h-12 "
						>
							<ArrowRightIcon className="w-5 h-5" />
						</ButtonCircle>
					</div>

				</div>
			</div>

		</div>
	);
};

export default ChatList;
